import React, { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { styled } from '../components/styled';
import SpButton from '../components/atoms/SpButton';
import SpTextInput from '../components/atoms/SpTextInput';
import { registerUser } from '../models/actions/Auth';
import { ArrowBack } from '@material-ui/icons';
import { labels } from '../pages/shared/translations';
import SpText from '../components/atoms/SpText';
import { theme } from '../components/theme';
import { withSnackbar } from '../components/atoms/SpSnackBar';
import { FormControlLabel, Grid, Radio } from '@material-ui/core';

const StyledRowForm = styled(Grid)({
  width: '100%',
  marginTop: '5%'
});

const StyledColumnRegistration = styled('div')({
  display: 'flex',
  maxHeight: '100%',
  flex: 1,
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '50%',
  margin: '0px auto',
  padding: '2%',
  marginTop: 40,
  borderRadius: 30,
  boxShadow: `1px 1px 11px 4px ${theme.colors.primary.lightBlue}`,
  background: 'white',
  overflowY: 'auto'
});

const TitleToolbarSection = styled('div')({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '100%'
});

const Registration = (props) => {
  const { control, register, handleSubmit, getValues, reset, errors, watch } = useForm();
  const history = useHistory();
  const watchConfirmPassword = watch('confirmPassword');

  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [inputError, setInputError] = useState('');

  useEffect(() => {
    setConfirmPasswordError(getValues('confirmPassword') !== getValues('password'));
  }, [watchConfirmPassword]);

  const registerUserServer = async (data) => {
    try {
      const response = await registerUser(data);
      if (response?.data?.message) {
        props.snackbarShowErrorMessage(response.data?.message);
      } else {
        history.push('/');
      }
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
  };

  return (
    <>
      <StyledColumnRegistration>
        <TitleToolbarSection>
          <ArrowBack
            onClick={() => history.push('/login')}
            style={{ width: 30, color: theme.colors.mainGreen.secondary, height: 50, cursor: 'pointer' }}
          ></ArrowBack>
          <SpText variant="h4">{labels.registration.actions.backToLogin}</SpText>
        </TitleToolbarSection>

        <form onSubmit={handleSubmit(registerUserServer)}>
          <Grid
            container
            direction="column"
          >
            <StyledRowForm
              item
              xs={12}
            >
              <SpText variant="h1PageTitle">{labels.registration.title}</SpText>
            </StyledRowForm>
            {inputError && (
              <StyledRowForm
                item
                xs={12}
              >
                <SpText variant="inputError">{inputError}</SpText>
              </StyledRowForm>
            )}
            <StyledRowForm
              item
              xs={12}
            >
              <SpTextInput
                name={'email'}
                style={{ autocomplete: 'off' }}
                inputRef={register({ required: true })}
                label={labels.registration.form.email}
              />
              {errors.email && <SpText variant="inputError">{labels.registration.emailRequired}</SpText>}
            </StyledRowForm>
            <StyledRowForm
              item
              xs={12}
            >
              <SpTextInput
                name={'username'}
                style={{ autocomplete: 'off' }}
                inputRef={register}
                label={labels.registration.form.username}
              />
            </StyledRowForm>
            <StyledRowForm
              item
              xs={12}
            >
              <SpTextInput
                name={'password'}
                type="password"
                style={{ autocomplete: 'off' }}
                inputRef={register({ required: true })}
                label={labels.registration.form.password}
              />
              {errors.password && <SpText variant="inputError">{labels.registration.passwordRequired}</SpText>}
            </StyledRowForm>
            <StyledRowForm
              item
              xs={12}
            >
              <SpTextInput
                name={'confirmPassword'}
                type="password"
                inputRef={register}
                label={labels.registration.form.confirmPassword}
              />
              {confirmPasswordError && <SpText variant="inputError">{labels.registration.passwordConfirm}</SpText>}
            </StyledRowForm>
            <StyledRowForm
              item
              xs={12}
            >
              <SpButton
                text={'Registrati'}
                disabled={confirmPasswordError}
                type="submit"
                buttonType={'accept'}
              />
            </StyledRowForm>
          </Grid>
        </form>
      </StyledColumnRegistration>
    </>
  );
};

export default withSnackbar(Registration);
